import React from 'react';
import PropTypes from 'prop-types';

import { ImageElement } from 'common/react/components/ImageElement';
import { SponsorWrapper } from './SponsorWrapper';

export const Sponsor = ({ promo, isV2 }) => {
    const link = promo?.links?.[0];

    return (
        <SponsorWrapper link={link}>
            <ImageElement
                url={`${promo.promoItem.onDemandUrl}?height=64`}
                title={promo.title}
                cssClass={
                    isV2
                        ? 'trade-radio-mini-player__sponsor-image'
                        : 'trade-radio__sponsor-image'
                }
                width={promo.promoItem?.originalDetails?.width}
                height={promo.promoItem?.originalDetails?.height}
            ></ImageElement>
        </SponsorWrapper>
    );
};

Sponsor.propTypes = {
    promo: PropTypes.object.isRequired,
    isV2: PropTypes.bool
};
